import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { updateorganisationThunk } from "../../asyncThunks/scope/scope";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const updateorganisation = createSlice({
    name: "updateorganisation",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(updateorganisationThunk.pending, (state, action) => {
            state.error = null;
            state.data = null;
            state.loading = true;
        });
        builder.addCase(updateorganisationThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(updateorganisationThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },

})


export default updateorganisation.reducer;